export enum EnvName {
    TESTING = 'testing',
    DEV = 'test',
    PROD = 'prod',
}
